import { ComplianceCaseSubStatus } from "../../../graphql/supergraphEnums";
import { GP_CASE_TYPE_LABELS } from "./constants";
import type { ActivityEvent, GpComplianceAuditLogEvent } from "./types";
import type { ComplianceCaseSubStatus as ComplianceCaseSubStatusType } from "../../../graphql/supergraphTypes";

const getSubStatusInfo = (
  subStatus?: ComplianceCaseSubStatusType | null,
  arenaName?: string,
): string | null => {
  if (!subStatus) return null;

  switch (subStatus) {
    case ComplianceCaseSubStatus.Approved:
      return "Approved";
    case ComplianceCaseSubStatus.Denied:
      return "Rejected";
    case ComplianceCaseSubStatus.Escalated:
      return arenaName ? `Escalated to ${arenaName}` : "Escalated";
    case ComplianceCaseSubStatus.Accepted:
      return "Accepted";
    case ComplianceCaseSubStatus.Rejected:
      return "Rejected";
    default:
      return null;
  }
};

export const transformGpAuditLogEvent = (
  event: GpComplianceAuditLogEvent,
  arenaName?: string,
): ActivityEvent | null => {
  const label = GP_CASE_TYPE_LABELS[event.caseType];
  if (!label) return null;

  const profileName = event.caseProfileName ?? "";
  const profileSuffix = profileName ? ` for ${profileName}` : "";

  let actionType: ActivityEvent["actionType"];
  let title: string;
  if (event.auditTag === "case_closed") {
    actionType = "completed";
    title = `${label} case completed${profileSuffix}`;
  } else if (event.eventType === "case_created") {
    actionType = "created";
    title = `${label} case created${profileSuffix}`;
  } else {
    return null;
  }

  const subStatusInfo =
    actionType === "completed" ? (getSubStatusInfo(event.caseSubStatus, arenaName) ?? "") : "";

  return {
    id: event.caseId,
    title,
    caseType: event.caseType,
    caseTypeLabel: label,
    subStatusInfo,
    entityNames: event.entityNames,
    profileName,
    positionCount: event.positionCount,
    timestamp: event.createdAt,
    actionType,
  };
};

export const filterAndTransformGpAuditLogEvents = (
  events: GpComplianceAuditLogEvent[],
  arenaName?: string,
): ActivityEvent[] =>
  events.reduce<ActivityEvent[]>((acc, event) => {
    const transformed = transformGpAuditLogEvent(event, arenaName);
    if (transformed) acc.push(transformed);
    return acc;
  }, []);
